import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormService } from '../../services/form.service';

@Component( {
	selector: 'app-utilities',
	templateUrl: './utilities.component.html',
	styleUrls: ['./utilities.component.scss']
} )
export class UtilitiesComponent implements OnInit {
	public formGroupName: string = 'utilities';
	public utilitiesForm!: UntypedFormGroup;

	constructor(public formService: FormService) {}

	ngOnInit(): void {
		this.utilitiesForm = this.formService.thirdPartyForm.get(this.formGroupName) as UntypedFormGroup;

		// Set default value for destination address from main form
		const movingToAddress = this.formService.mainForm.get('movingTo')?.get('address')?.value;
		if (movingToAddress) {
			this.utilitiesForm.get('destinationAddress')?.setValue(movingToAddress);
		}

		// Set default value for destination postcode from main form
		const movingToPostcode = this.formService.mainForm.get('movingTo')?.get('postcode')?.value;
		if (movingToPostcode) {
			this.utilitiesForm.get('destinationPostcode')?.setValue(movingToPostcode);
		}
	}

	onSubmit(): void {
		this.formService.submitThirdPartyFormGroup(this.utilitiesForm);
	}
}
